// translations/it.ts
import { TranslationKeys } from '../index';

export const it: TranslationKeys = {
  header: {
    tutorialButton: "Tutorial",
    currentLanguage: "Attuale"
  },
  hero: {
    title: "Gioca a Sudoku Vs Ora!",
    description: "Preparati per una sfida di Sudoku come nessun'altra! Divertiti a praticare da solo o sfida gli amici — scarica ora e vivi l'emozione!",
    howToPlay: "Come Giocare",
    discordButton: "Unisciti al nostro Discord",
    googlePlay: {
      topText: "Disponibile su",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "Scarica su",
      bottomText: "App Store"
    },
    botButtonShow: "Hai bisogno di aiuto? Chiedi al nostro Bot!",
    botButtonHide: "Nascondi Assistente"
  },
  footer: {
    followUs: "SEGUICI SU",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. Tutti i diritti riservati."
  },
  beginnersGuide: {
    modalTitle: "GUIDA PER PRINCIPIANTI",
    originsTab: "ORIGINI DEL SUDOKU",
    basicsTab: "LE BASI DEL SUDOKU",
    rulesTab: "REGOLE DEL GIOCO VS",
    origins: {
      bulletOne: "Ispirato ai quadrati latini; pubblicato per la prima volta nel 1979 da Howard Garns.",
      bulletTwo: "Divenne popolare in Giappone negli anni '80, ribattezzato “Sudoku”. Ha guadagnato fama mondiale negli anni 2000.",
      bulletThree: "Griglia 9x9 con nove sottogriglie 3x3; riempire con numeri da 1 a 9 senza ripetizioni in righe, colonne o sottogriglie.",
      bulletFour: "Amato da milioni, con molte varianti e nuove sfide.",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "Inserisci il numero mancante!",
      correct: "CORRETTO!",
      incorrect: "NON CORRETTO",
      instructions: "Completa il puzzle 3X3 inserendo il numero corretto nello spazio evidenziato. Ogni riga, colonna e riquadro deve contenere ogni numero esattamente una volta. Seleziona il numero corretto. Scegli saggiamente!",
      feedbackCorrect: "HAI RISOLTO IL TUO PRIMO RIQUADRO!",
      feedbackIncorrect: "RIPROVA!",
      basicsStep2: {
        instructions: "Completa il puzzle 4X4 selezionando il numero corretto per lo spazio evidenziato. Ogni riga, colonna e riquadro deve contenere ogni numero esattamente una volta. Seleziona il numero corretto. Scegli saggiamente!",
        feedbackCorrect: "SEI INARRESTABILE!"
      },
      basicsStep3: {
        instructions: "Completa il puzzle 4X4 selezionando il numero corretto per lo spazio evidenziato. Ogni riga, colonna e riquadro deve contenere ogni numero esattamente una volta. Seleziona il numero corretto. Scegli saggiamente!",
        feedbackCorrect: "SOLUZIONE PERFETTA!",
        feedbackIncorrect: "NON CORRETTO - RIPROVA!"
      },
      congratulations: {
        title: "Congratulazioni!",
        subtitle: "Hai completato con successo il tutorial sulle basi del Sudoku! La tua dedizione e il tuo impegno hanno dato i loro frutti, e ora sei dotato delle competenze essenziali per affrontare i puzzle di Sudoku con fiducia.",
        nextStepsTitle: "Prossimi Passi",
        nextStepsText: "Ora è il momento di mettere alla prova le tue abilità! Scarica il gioco del Sudoku oggi e immergiti in una varietà di puzzle. Che tu preferisca una partita veloce in singolo o voglia impegnarti in una competizione amichevole, puoi scegliere di giocare in modalità singola o in modalità vs contro un avversario.",
        ctaHeader: "Pronto per una partita?",
        ctaHighlight: "Scarica Ora!",
        rulesTitle: "Padroneggia le Regole del Gioco",
        rulesText: "Prima di iniziare, assicurati di consultare le Regole del Gioco di Sudoku VS. Comprendere le regole e il sistema di punteggio può darti un vantaggio quando giochi contro avversari. Questa conoscenza migliorerà la tua esperienza e ti aiuterà a elaborare strategie efficaci!"
      }
    },
    gameRules: {
      notification: {
        important: "Importante: ",
        text: "Abilita le notifiche per la migliore esperienza!"
      },
      rulesHeader: "Regole",
      rulesList: {
        rule1_pre: "Accetta o crea un invito per una ",
        rule1_strong: "partita amichevole o casuale",
        rule1_post: ".",
        rule2_pre: "Un giocatore viene ",
        rule2_strong: "scelto a caso per iniziare.",
        rule3: "I giocatori si alternano fino al completamento del tabellone.",
        rule4_pre1: "Ogni ",
        rule4_strong1: "turno dura 60 secondi,",
        rule4_pre2: " con un limite di ",
        rule4_strong2: "5 numeri per turno.",
        rule5_pre: "È consentito solo ",
        rule5_strong: "1 suggerimento",
        rule5_post: " per turno.",
        rule6_pre: "Il giocatore con ",
        rule6_strong: "il punteggio più alto vince",
        rule6_post: " la partita.",
        rule7_pre: "In caso di ",
        rule7_strong_pre: "pareggio",
        rule7_pre2: ", il giocatore con più inserimenti ",
        rule7_strong_post: "vince",
        rule7_post: " la partita.",
        rule8: "Se non termini il tuo turno entro 24 ore, perdi automaticamente la partita."
      },
      rulesWarning: "Gioca il tuo turno entro 24 ore o perderai automaticamente la partita",
      gameControls: {
        header: "Controlli di Gioco",
        list: {
          control1_pre: "Usa la ",
          control1_strong: "Bandiera di Resa",
          control1_post: " per abbandonare la partita.",
          control2_pre: "Usa la ",
          control2_strong: "Gomma",
          control2_post: " per correggere un errore.",
          control3_pre: "Usa ",
          control3_strong: "Fine Turno",
          control3_post: " se hai completato tutti i tuoi inserimenti prima dello scadere del tempo."
        }
      },
      scoring: {
        header: "Punteggio",
        list: {
          score1_pre1: "Guadagna ",
          score1_strong1: "1 punto",
          score1_pre2: " per il posizionamento di un numero ",
          score1_span: "corretto",
          score1_post: ".",
          score2_pre1: "Perdi ",
          score2_strong1: "1 punto",
          score2_pre2: " per ogni posizionamento di numero ",
          score2_span: "errato",
          score2_post: ".",
          score3_pre1: "Guadagna ",
          score3_strong1: "5 punti",
          score3_pre2: " per ogni riga, colonna e riquadro ",
          score3_span: "risolto",
          score3_post: "."
        }
      },
    },
    controller: {
      previous: "Precedente",
      of: " di ",
      close: "Chiudi",
      next: "Successivo",
      gameRules: "Regole del Gioco",
    },
  },
  tutorials: {
    modalTitle: "Tutorial",
    tabs: {
      introduction: "Introduzione",
      gettingStarted: "Per Iniziare",
      vsFriends: "Contro Amici",
      howToPlay: "Come Giocare",
    },
    messages: {
      loading: "Caricamento dei tutorial...",
      error: "Errore nel caricamento dei tutorial:",
      fallback: "Utilizzo dei dati di fallback...",
      empty: "Nessun tutorial disponibile per questa sezione.",
    },
  },
  cookieConsent: {
    title: "Gestisci Preferenze di Consenso",
    description: "Utilizziamo i cookie per migliorare la tua esperienza su Sudoku VS, analizzare il nostro traffico e fornire annunci personalizzati.",
    acceptAll: "Accetta Tutti i Cookie",
    confirmChoices: "Conferma Scelte",
    performance: {
      title: "Cookie di Performance",
      description: "Ci consentono di raccogliere dati per migliorare il nostro gioco e i nostri servizi attraverso l'analisi dell'utilizzo."
    },
    advertising: {
      title: "Pubblicità",
      adStorage: "Consente la memorizzazione di dati pubblicitari sul tuo dispositivo",
      adMeasurement: "Consente la raccolta di dati per la misurazione della pubblicità",
      adPersonalization: "Ci consente di mostrarti annunci personalizzati in base ai tuoi interessi"
    },
    landing: {
        title: "Informativa sui Cookie",
        description: "Utilizziamo i cookie per migliorare la tua esperienza su Sudoku VS, analizzare il nostro traffico e fornire annunci personalizzati. Puoi impostare quali cookie desideri consentire prima di continuare.",
        acceptAll: "Accetta tutti i Cookie",
        customizeSettings: "Personalizza Impostazioni",
        fineprint: "Cliccando su \"accetta tutti i cookie\", accetti che<br />Sudoku VS possa memorizzare cookie sul tuo dispositivo"
    }
  },

    privacyPolicy: {
    modalTitle: "Informativa sulla Privacy",
    sections: {
      introduction: {
        title: "1. Introduzione",
        p1: "Benvenuto su Sudoku VS. Ci impegniamo a proteggere la tua privacy e a garantire che tu abbia un'esperienza positiva sul nostro sito web. Questa Informativa sulla Privacy spiega come raccogliamo, utilizziamo e proteggiamo le tue informazioni quando utilizzi la nostra piattaforma di gioco Sudoku.",
        p2: "Utilizzando Sudoku VS, accetti la raccolta e l'uso delle informazioni in conformità con questa politica."
      },
      informationWeCollect: {
        title: "2. Informazioni che Raccogliamo",
        p1: "Raccogliamo diversi tipi di informazioni per fornire e migliorare i nostri servizi:",
        list: {
          usageData: "Dati di Utilizzo: Raccogliamo automaticamente informazioni su come interagisci con il nostro gioco, incluse statistiche di gioco, tempi di completamento dei puzzle, livelli di difficoltà giocati e preferenze di gioco.",
          deviceInfo: "Informazioni sul Dispositivo: Potremmo raccogliere informazioni sul dispositivo che utilizzi per accedere a Sudoku VS, incluso tipo di dispositivo, tipo di browser, indirizzo IP e sistema operativo.",
          cookies: "Cookie e Dati di Tracciamento: Utilizziamo cookie e tecnologie di tracciamento simili per migliorare la tua esperienza e raccogliere dati analitici."
        }
      },
      howWeUseInfo: {
        title: "3. Come Utilizziamo le Tue Informazioni",
        p1: "Utilizziamo le informazioni raccolte per i seguenti scopi:",
        list: {
          gameImprovement: "Miglioramento del Gioco: Per analizzare i modelli di gioco e migliorare i nostri puzzle Sudoku, algoritmi di difficoltà e l'esperienza utente complessiva.",
          performanceAnalytics: "Analisi delle Prestazioni: Per monitorare e analizzare le tendenze di utilizzo, misurare l'efficacia dei nostri servizi e identificare aree di miglioramento.",
          personalization: "Personalizzazione: Per fornirti raccomandazioni di gioco personalizzate e contenuti su misura basati sulle tue preferenze di gioco.",
          technicalSupport: "Supporto Tecnico: Per risolvere problemi, correggere bug e garantire il funzionamento regolare della nostra piattaforma."
        }
      },
      cookies: {
        title: "4. Cookie e Tecnologie di Tracciamento",
        p1: "Sudoku VS utilizza cookie per migliorare la tua esperienza. Hai la possibilità di gestire le tue preferenze sui cookie:",
        performanceCookies: {
          title: "Cookie di Prestazione:",
          description: "Questi cookie ci permettono di raccogliere dati per migliorare il nostro gioco e servizi attraverso l'analisi dell'utilizzo. Ci aiutano a capire come i giocatori interagiscono con i nostri puzzle, quali funzionalità sono più popolari e dove possiamo apportare miglioramenti. Questi dati sono essenziali per migliorare il gameplay e creare esperienze Sudoku migliori."
        },
        advertisingCookies: {
          title: "Cookie Pubblicitari:",
          list: [
            "Permettono la memorizzazione dei dati pubblicitari sul tuo dispositivo",
            "Abilitano la raccolta di dati per la misurazione e l'efficacia della pubblicità",
            "Ci permettono di mostrarti annunci personalizzati basati sui tuoi interessi e comportamento di gioco"
          ]
        },
        p2: "Puoi controllare le tue preferenze sui cookie attraverso il banner di consenso ai cookie che appare quando visiti per la prima volta il nostro sito web. Puoi modificare le tue impostazioni in qualsiasi momento attraverso le impostazioni del tuo browser, sebbene la disabilitazione di alcuni cookie possa influire sulla funzionalità del sito web."
      },
      thirdParty: {
        title: "5. Servizi di Terze Parti",
        p1: "Sudoku VS si integra con i seguenti servizi di terze parti:",
        gemini: {
          title: "Assistente AI Google Gemini:",
          description: "Il nostro bot di aiuto è alimentato da Google Gemini con una base di conoscenza integrata per assisterti con domande relative al gioco, fornire suggerimenti Sudoku e aiutare a risolvere problemi. Quando interagisci con il bot, le tue query possono essere elaborate dai sistemi di Google. Si prega di fare riferimento all'Informativa sulla Privacy di Google per informazioni su come gestiscono i dati."
        },
        youtube: {
          title: "Video Incorporati di YouTube:",
          description: "Utilizziamo overlay video di YouTube per fornire contenuti tutorial e guide di gioco direttamente all'interno del nostro sito web. Quando interagisci con questi video, YouTube può raccogliere dati secondo la sua politica sulla privacy. Puoi guardare video senza lasciare Sudoku VS, ma i meccanismi di tracciamento di YouTube potrebbero ancora applicarsi."
        },
        advertising: {
          title: "Partner Pubblicitari:",
          description: "Lavoriamo con partner pubblicitari di terze parti per visualizzare annunci sulla nostra piattaforma. Questi partner possono utilizzare cookie e tecnologie simili per raccogliere informazioni sulla tua attività di navigazione per scopi pubblicitari personalizzati."
        }
      },
      dataSecurity: {
        title: "6. Sicurezza dei Dati",
        p1: "Prendiamo sul serio la sicurezza dei tuoi dati e implementiamo misure tecniche e organizzative appropriate per proteggere le tue informazioni da accesso, alterazione, divulgazione o distruzione non autorizzati. Tuttavia, si prega di notare che nessun metodo di trasmissione su Internet o archiviazione elettronica è sicuro al 100%.",
        p2: "Il nostro sito web utilizza protocolli di sicurezza standard del settore ed è verificato dal sigillo di sicurezza GoDaddy per garantire un'esperienza di navigazione sicura."
      },
      privacyRights: {
        title: "7. I Tuoi Diritti sulla Privacy",
        p1: "Hai determinati diritti riguardo alle tue informazioni personali:",
        list: {
          access: "Accesso: Puoi richiedere informazioni sui dati che deteniamo su di te",
          correction: "Correzione: Puoi richiedere la correzione di informazioni inesatte",
          deletion: "Cancellazione: Puoi richiedere la cancellazione dei tuoi dati, soggetti a obblighi legali",
          optOut: "Rinuncia: Puoi rinunciare alla pubblicità personalizzata attraverso le tue preferenze sui cookie",
          portability: "Portabilità dei Dati: Puoi richiedere una copia dei tuoi dati in un formato portatile"
        }
      },
      childrenPrivacy: {
        title: "8. Privacy dei Minori",
        p1: "Sudoku VS è progettato per un pubblico generale. Non raccogliamo consapevolmente informazioni personali da bambini di età inferiore ai 13 anni. Se sei un genitore o tutore e ritieni che tuo figlio ci abbia fornito informazioni personali, ti preghiamo di contattarci in modo da poter intraprendere le azioni appropriate."
      },
      changes: {
        title: "9. Modifiche a Questa Informativa sulla Privacy",
        p1: "Potremmo aggiornare questa Informativa sulla Privacy di volta in volta per riflettere cambiamenti nelle nostre pratiche o per ragioni legali, operative o normative. Ti informeremo di eventuali modifiche materiali pubblicando la nuova Informativa sulla Privacy su questa pagina e aggiornando la data dell'\"Ultimo Aggiornamento\" di seguito.",
        p2: "Ti incoraggiamo a rivedere periodicamente questa Informativa sulla Privacy per rimanere informato su come proteggiamo le tue informazioni."
      },
      contact: {
        title: "10. Contattaci",
        p1: "Se hai domande, preoccupazioni o richieste riguardanti questa Informativa sulla Privacy o le nostre pratiche sui dati, ti preghiamo di contattarci:",
        email: "Email: privacy@sudoku.vs",
        website: "Sito web: www.sudoku.vs",
        p2: "Risponderemo alla tua richiesta il prima possibile."
      }
    },
    footer: {
      lastUpdated: "Ultimo aggiornamento: 10 ottobre 2025",
      effectiveDate: "Data di efficacia: 10 ottobre 2025"
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},
  copywright: {
    text: 'Copyright © 2025 Software Architects Ltd. Tutti i diritti riservati.'
  }
};